<template>
  <div>
    <el-date-picker
      v-if="isDesktop"
      v-model="value"
      unlink-panels
      type="daterange"
      range-separator="To"
      start-placeholder="Start date"
      end-placeholder="End date"
      value-format="YYYY-MM-DD"
      @update:modelValue="update"
    />
    <div v-else>
      <el-date-picker
        v-model="dateFrom"
        type="date"
        value-format="YYYY-MM-DD"
        placeholder="Start date"
      />
      <el-date-picker
        v-model="dateTo"
        class="mt-1"
        type="date"
        value-format="YYYY-MM-DD"
        placeholder="End date"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'DateRangeSelector',
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)

    function update(newValue: string[]) {
      context.emit('update:modelValue', newValue)
    }

    const { isDesktop } = useResize()

    const dateFrom = computed({
      get: () => {
        return props.modelValue[0]
      },
      set: (newVal) => {
        context.emit('update:modelValue', [newVal, props.modelValue[1]])
      }
    })

    const dateTo = computed({
      get: () => {
        return props.modelValue[1]
      },
      set: (newVal) => {
        context.emit('update:modelValue', [props.modelValue[0], newVal])
      }
    })
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { update, isDesktop, dateTo, dateFrom, value }
  }
})
</script>

<style lang="scss" scoped>
:deep(.el-range-separator) {
  width: 10%;
}

.el-date-editor {
  width: 100%;
}

.desktop .el-date-editor {
  width: auto;
}
</style>
